import { creatorbase } from '@round/api';
import { ExploreAccountDetails } from '../../types';
import { CreatorAccountRow } from '../CreatorAccountsTable/helpers';

/** An item with the account it created as Creator Explore has it, and that account's image. */
export type BulkUploadItemRow = creatorbase.CreatorBulkUploadItem & ExploreAccountDetails;

/** A created item as the accounts table shows it: by the handle it was submitted as. */
export const toCreatorAccountRow = (row: BulkUploadItemRow): CreatorAccountRow => ({
    key: row.id,
    platform: row.platform,
    handle: row.identifier,
    client_influencer_id: row.client_influencer_id,
    client_influencer_account_id: row.client_influencer_account_id,
    exploreAccount: row.exploreAccount,
    imageUrl: row.imageUrl,
});
